import React, { FC, useEffect } from 'react';
import { observer } from 'mobx-react';
import Skeleton from 'react-loading-skeleton';
import { localeStore } from 'src/mobx/localesStore';
import InnerHtml from 'src/view/components/InnerHtml/InnerHtml';
import ScreenWrapper from 'src/view/containers/ScreenWrapper/ScreenWrapper';
import { infoStore } from 'src/mobx/infoStore';

export const FranchiseScreen: FC = observer(() => {
  useEffect(() => {
    infoStore.getInfo('franchise');

    return () => {
      infoStore.resetStore();
    };
  }, []);

  if (infoStore.loading || !localeStore.localizationLoaded) {
    return (
      <div className="d-flex flex-column full-width">
        <Skeleton width={'40%'} height={36} className="mt-5" />

        <div className="mt-5">
          <Skeleton className={'text-size-18'} width={'100%'} count={8} style={{ marginBottom: 10 }} />
          <Skeleton width={'55%'} count={1} style={{ marginBottom: 10 }} />
        </div>
      </div>
    );
  }

  return (
    <ScreenWrapper>
      <div className="full-width">
        <InnerHtml html={infoStore.template} />
      </div>
    </ScreenWrapper>
  );
});
